import { useLocalObservable } from "mobx-react-lite";
import { Page, updatePageChangedWithRouterEvent } from "./page";
export const useUpdateRouterHistory = (param)=>{
    let { router , defaultPageLimit  } = param;
    const store = useLocalObservable(()=>({
            filterType: "all",
            filter: {},
            paging: Page({
                pageSize: defaultPageLimit
            }),
            // 업데이트 할 때, 항상 실행 할 것
            invalidate: function(forceParams) {
                let isReplace = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                if (forceParams) {
                    updatePageChangedWithRouterEvent(forceParams, router, isReplace);
                } else {
                    const params = {
                        ...store.filter,
                        offset: store.paging.offset,
                        limit: store.paging.limit
                    };
                    updatePageChangedWithRouterEvent(params, router, isReplace);
                }
            },
            updatePagination: (offset, limit)=>{
                store.paging.setCurrent(offset, limit !== null && limit !== void 0 ? limit : defaultPageLimit);
            },
            updateFilterSearch (name, value) {
                const newFilter = {
                    ...store.filter
                };
                newFilter[name] = value;
                store.filter = newFilter;
            },
            deleteFilterSearch (name) {
                delete store.filter[name];
            },
            clearAllFilterSearch () {
                store.filter = {};
            },
            clearAll () {
                this.clearAllFilterSearch();
                this.updatePagination(0);
            },
            updateFilterSearchType (searchType) {
                store.filterType = searchType;
                if (searchType !== "all") {
                    const [category, value] = searchType.split("/");
                    store.filter[category] = value.toString();
                } else {
                    store.clearAllFilterSearch();
                }
            }
        }));
    return store;
};
